import * as Yup from 'yup';
import { emailRegex } from '@pharmaplan/common';
import strings from '../../../../../localization';
import { nameRegex, onlyNumbersRegex, phoneRegex, postalCodeRegExp } from '../../../../../helpers/Constants';
import { operationsValidation } from '../../../../Profile/FormValidation';

const pharmacyEditValidator = () =>
  Yup.object().shape({
    name: Yup.string()
      .required(strings.requiredField),
    number: Yup.string().nullable().matches(
      onlyNumbersRegex,
      strings.formatString(
        strings.numberValidation,
        strings.bannerNumber,
      ) as string,
    ),
    phone: Yup.string()
      .required(strings.requiredField)
      .max(
        12,
        strings.formatString(strings.phoneValidation, strings.phone) as string,
      )
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.phone) as string,
      )
      .matches(phoneRegex, `${strings.wrongFormat} : ###-###-####`),
    emergencyPhone: Yup.string()
      .required(strings.requiredField)
      .max(
        12,
        strings.formatString(strings.phoneValidation, strings.emergencyPhone) as string,
      )
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.emergencyPhone) as string,
      )
      .matches(phoneRegex, `${strings.wrongFormat} : ###-###-####`),
    address: Yup.string().required(strings.requiredField),
    postalCode: Yup.string()
      .required(strings.requiredField)
      .matches(postalCodeRegExp, strings.postalCodeValidation),
    city: Yup.string().required(strings.requiredField),
    fax: Yup.string()
      .max(
        12,
        strings.formatString(strings.phoneValidation, strings.fax) as string,
      )
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.fax) as string,
      )
      .matches(phoneRegex, `${strings.wrongFormat} : ###-###-####`)
      .nullable(),
    primaryContactName: Yup.string()
      .required(strings.requiredField)
      .matches(nameRegex, strings.pleaseEnterValidName),
    primaryContactPhone: Yup.string()
      .required(strings.requiredField)
      .min(
        12,
        strings.formatString(
          strings.phoneValidation,
          strings.homePhone,
        ) as string,
      )
      .matches(phoneRegex, `${strings.wrongFormat} : ###-###-####`)
      .nullable(),
    primaryContactMobile: Yup.string()
      .max(
        12,
        strings.formatString(strings.phoneValidation, strings.mobile) as string,
      )
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.mobile) as string,
      )
      .matches(phoneRegex, `${strings.wrongFormat} : ###-###-####`)
      .nullable(),
    primaryContactEmail: Yup.string()
      .matches(emailRegex, strings.emailValid)
      .required(strings.requiredField)
      .nullable(),
    communicationEmail: Yup.string()
      .matches(emailRegex, strings.emailValid)
      .nullable(),
    secondaryContactName: Yup.string()
      .matches(nameRegex, strings.pleaseEnterValidName)
      .nullable(),
    secondaryContactPhone: Yup.string()
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.phone) as string,
      )
      .matches(phoneRegex, `${strings.wrongFormat} : ###-###-####`)
      .nullable(),
    secondaryContactMobile: Yup.string()
      .max(
        12,
        strings.formatString(strings.phoneValidation, strings.mobile) as string,
      )
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.mobile) as string,
      )
      .matches(phoneRegex, `${strings.wrongFormat} : ###-###-####`)
      .nullable(),
    secondaryContactEmail: Yup.string().matches(emailRegex, strings.emailValid).nullable(),
    accountingContactName: Yup.string()
      .required(strings.requiredField)
      .matches(nameRegex, strings.pleaseEnterValidName)
      .nullable(),
    accountingContactPhone: Yup.string()
      .required(strings.requiredField)
      .min(
        12,
        strings.formatString(
          strings.phoneValidation,
          strings.homePhone,
        ) as string,
      )
      .matches(phoneRegex, `${strings.wrongFormat} : ###-###-####`)
      .nullable(),
    accountingContactMobile: Yup.string()
      .max(
        12,
        strings.formatString(strings.phoneValidation, strings.mobile) as string,
      )
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.mobile) as string,
      )
      .matches(phoneRegex, `${strings.wrongFormat} : ###-###-####`)
      .nullable(),
    accountingContactEmail: Yup.string()
      .required(strings.requiredField)
      .matches(emailRegex, strings.emailValid)
      .nullable(),
    weekVolume: operationsValidation(),
    weekDayPharmacists: operationsValidation(),
    weekNightPharmacists: operationsValidation(),
    weekDayTechs: operationsValidation(),
    weekNightTechs: operationsValidation(),
    weekendVolume: operationsValidation(),
    weekendDayPharmacists: operationsValidation(),
    weekendNightPharmacists: operationsValidation(),
    weekendDayTechs: operationsValidation(),
    weekendNightTechs: operationsValidation(),
  });

export default pharmacyEditValidator;
